import React from 'react';
import Hero from '../../components/public/Hero';

const WhoWeServe = () => {
    const audienceGroups = [
        {
            title: 'Salaried Professionals',
            description: 'Build clarity around income stability, career decisions, tax planning, and long-term wealth building within structured employment',
            color: 'light'
        },
        {
            title: 'Entrepreneurs & MSMEs',
            description: 'Navigate irregular cash flows, business investment decisions, personal-business separation, and growth planning with confidence',
            color: 'light'
        },
        {
            title: 'Families Seeking Stability',
            description: 'Create household economic systems that account for multiple members, long-term goals, education needs, and generational planning',
            color: 'light'
        },
        {
            title: 'Those Feeling Overwhelmed',
            description: 'Individuals who find financial complexity paralyzing and need structured guidance to regain control and understanding',
            color: 'light'
        },
        {
            title: 'Decision-Makers',
            description: 'Leaders who understand that informed choices require complete information and prefer strategy over impulse',
            color: 'light'
        }
    ];

    const characteristics = [
        {

            title: 'Value Clarity',
            description: 'You prioritize understanding over quick fixes'
        },
        {

            title: 'Seek Sustainability',
            description: 'You focus on long-term stability rather than short-term gains'
        },
        {

            title: 'Appreciate Structure',
            description: 'You value systematic approaches to complex decisions'
        },
        {

            title: 'Question Urgency',
            description: 'You are skeptical of pressure tactics and rushed decisions'
        }
    ];

    return (
        <div className="who-we-serve-page">
            <Hero
                title="Who Yathartha Serves"
                subtitle="Our Audience"
                description="Designed for individuals, families and organizations who recognize that lasting stability requires understanding, not urgency"
                backgroundImage="/Advice.jpeg"
            />

            {/* Intro Section */}
            <section className="serve-intro-section">
                <div className="container">
                    <div className="serve-intro-text">
                        <p>
                            <strong>Yathartha</strong> is designed for individuals, families and organizations who recognize that lasting stability requires understanding, not urgency.
                        </p>
                        <p>
                            Our system serves those who value clarity over quick fixes and sustainable progress over dramatic promises.
                        </p>
                    </div>
                </div>
            </section>

            {/* Audience Groups */}
            <section className="audience-groups-section">
                <div className="container">
                    <div className="audience-groups-grid">
                        {audienceGroups.map((group, index) => (
                            <div
                                key={index}
                                className={`audience-group-box ${group.color}`}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <h3>{group.title}</h3>
                                <p>{group.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Bottom Message */}
            <section className="serve-message-section">
                <div className="container">
                    <div className="serve-message-card">

                        <p>
                            <strong>Yathartha is for those who prefer understanding over urgency.</strong> If you value knowing where you stand more than being told what to do, this system is designed for you.
                        </p>
                    </div>
                </div>
            </section>

            {/* Characteristics Grid */}
            <section className="characteristics-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">You'll Thrive Here If You</h2>
                        <p className="section-description">
                            Characteristics of those who benefit most from our approach
                        </p>
                    </div>
                    <div className="characteristics-grid">
                        {characteristics.map((char, index) => (
                            <div
                                key={index}
                                className="characteristic-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="char-icon">{char.icon}</div>
                                <h3>{char.title}</h3>
                                <p>{char.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            {/* <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Does This Sound Like You?</h2>
                        <p>Discover how our approach can bring clarity to your journey</p>
                        <div className="cta-buttons">
                            <a href="/begin-with-clarity" className="cta-button primary">
                                Start Your Journey
                            </a>
                            <a href="/contact" className="cta-button dark">
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default WhoWeServe;
